import React from 'react';

const LinkMediaVideoHeader = () => {
  return (
    <header id="aaaa" className="p-7">
      <div className="flex justify-between items-center sm:h-16">
        <div style={{ opacity: 1, willChange: 'auto', transform: 'none' }}>
          <div className="hidden sm:block">
            <div className="flex items-center flex-col sm:flex-row">
              <div className="w-16 h-16 mx-auto p-5 bg-white rounded-full relative flex items-center justify-center overflow-hidden">
                <img
                  alt="brand"
                  loading="lazy"
                  decoding="async"
                  src="https://img.vidflow.co/studio/cbisb64y/media/1nxr5axc/aaaaaaaaaaaaaaaa.png?width=480&height=480&optimize=image"
                  style={{
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    inset: 0,
                    objectFit: 'cover',
                    color: 'transparent',
                  }}
                />
              </div>
              <div className="flex flex-col items-center justify-center sm:justify-start sm:ml-5">
                <div className="w-full text-base text-white font-medium my-2 brand-name-shadow">
                  VidMantra
                </div>
                {/*<button className="w-full text-xs theme-link flex items-center justify-center sm:justify-start brand-name-shadow">
                  <div className="text-xs sm:text-[10px]">LEARN MORE</div>
                  <div className="ml-1">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="angle-down"
                      className="svg-inline--fa fa-angle-down"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                      />
                    </svg>
                  </div>
                </button>
*/}              </div>
            </div>
          </div>
        </div>

        <div
          className="flex items-center space-x-2.5"
          style={{ opacity: 1, willChange: 'auto', transform: 'none' }}
        >
          <div className="flex sm:flex sm:items-center space-x-2.5">
            <div className="relative flex" id="watch-on-tv">
              <button
                id="gallery-tv-connect"
                className="flex text-white text-base rounded-full h-10 w-24  items-center justify-center header-icons-bg tv"
              >
                <div className="theme-link mr-3">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="tv"
                    className="svg-inline--fa fa-tv"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                  >
                    <path
                      fill="currentColor"
                      d="M64 64l0 288 512 0 0-288L64 64zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM128 448l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                    />
                  </svg>
                </div>
                <div className="text-base font-medium">TV</div>
              </button>
            </div>

            <div className="relative flex" id="gallery-share">
              <button className="text-white text-base rounded-full h-10 w-12 flex items-center justify-center header-icons-bg">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="share-nodes"
                  className="svg-inline--fa fa-share-nodes"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LinkMediaVideoHeader;
